import { AUDIO_STORAGE_KEY, DEFAULT_AUDIO_PREFS, clampVolume, type AudioPreferencesV1 } from './types'

export function normalizeAudioPrefs(raw: unknown): AudioPreferencesV1 {
  if (!raw || typeof raw !== 'object') return { ...DEFAULT_AUDIO_PREFS }
  const o = raw as Record<string, unknown>
  return {
    version: 1,
    muted: o.muted === true,
    masterVolume: clampVolume(typeof o.masterVolume === 'number' ? o.masterVolume : DEFAULT_AUDIO_PREFS.masterVolume),
    sfxVolume: clampVolume(typeof o.sfxVolume === 'number' ? o.sfxVolume : DEFAULT_AUDIO_PREFS.sfxVolume),
    uiVolume: clampVolume(typeof o.uiVolume === 'number' ? o.uiVolume : DEFAULT_AUDIO_PREFS.uiVolume)
  }
}

export function loadAudioPreferences(
  storage?: Pick<Storage, 'getItem'>
): AudioPreferencesV1 {
  try {
    const store = storage ?? (typeof localStorage !== 'undefined' ? localStorage : undefined)
    if (!store) return { ...DEFAULT_AUDIO_PREFS }
    const raw = store.getItem(AUDIO_STORAGE_KEY)
    if (!raw) return { ...DEFAULT_AUDIO_PREFS }
    return normalizeAudioPrefs(JSON.parse(raw))
  } catch {
    return { ...DEFAULT_AUDIO_PREFS }
  }
}

export function saveAudioPreferences(
  prefs: AudioPreferencesV1,
  storage?: Pick<Storage, 'setItem'>
): void {
  try {
    const store = storage ?? (typeof localStorage !== 'undefined' ? localStorage : undefined)
    if (!store) return
    store.setItem(AUDIO_STORAGE_KEY, JSON.stringify({ ...prefs, version: 1 as const }))
  } catch {
    // Ignore quota / private mode — audio keeps working with in-memory prefs.
  }
}
